import { Balance, BalanceLP, PriceList, Token } from '@jdiyield/interfaces'
import BigNumber from 'bignumber.js'
import Web3 from 'web3'

import StakingAbi from '../abi/stakingHorizon.json'
import { calculate } from '../calculate'
import getNodeUrl from '../rpcRandom'
import { StakeFunc, StakeProps } from '../types'
import { safeGasEstimates } from '../utils'

const stakingContractArray = [
  '0xdff88a0a43271344b760b58a35076bf05524195c', //PHB
  '0x67D5a94F444DF4bBA254645065a4137fc665Bf98', //HZN
  '0x84838d0AB37857fAd5979Fcf6BDDf8ddb1cC1dA8' //HZN_BNB_LP
]

export const getStakingHorizon = async (
  walletAddress: string,
  tokens: Token[],
  priceList: PriceList
): Promise<(Balance | BalanceLP)[]> => {
  try {
    const completeBalance = await Promise.all<Balance | BalanceLP>(
      stakingContractArray.map(async (contract, index) => {
        const RPC_URL = getNodeUrl(56)
        const web3 = new Web3(RPC_URL)
        const ct = new web3.eth.Contract(StakingAbi as any, contract)
        const balanceStakgingOf = await ct.methods.balanceOf(walletAddress).call()
        const reward = await ct.methods.earned(walletAddress).call()
        const lpToken = await ct.methods.stakingToken().call()

        let _balanceLP
        try {
          _balanceLP = await calculate(
            web3,
            {
              pool: index,
              lpAddress: lpToken,
              balance: balanceStakgingOf.toString(),
              availableBalanceOf: '0'
            },
            '0x05fF2B0DB69458A0750badebc4f9e13aDd608C7F',
            tokens,
            priceList
          )
        } catch {
          return undefined
        }

        return {
          ..._balanceLP,
          reward
        }
      })
    )

    const complete = await Promise.all<BalanceLP | Balance>(
      completeBalance
        .filter((value) => !!value)
        .map(async (i: any) => {
          if (i?.tokenA) {
            const result: BalanceLP = {
              ...i,
              availableBalanceOf: '0',
              // availableBalanceOf: new BigNumber(await balanceOf(walletAddress, i.lpAddress)).dividedBy(1e18).toString(),
              reward: i.reward / 1e18,
              // // rewardUSD: completePendingReward.find((a: any) => a.pool === i.pool)?.rewardUSD,
              rewardSymbol: 'HZN'
            }
            return result
          } else {
            const result: Balance = {
              ...i,
              availableBalanceOf: '0',
              // availableBalanceOf: new BigNumber(await balanceOf(walletAddress, i.lpAddress)).dividedBy(1e18).toString(),
              reward: i.reward / 1e18,
              // // rewardUSD: completePendingReward.find((a: any) => a.pool === i.pool)?.rewardUSD,
              rewardSymbol: 'HZN'
            }
            return result
          }
        })
    )
    return complete ? complete?.filter((i) => +i.balance > 0) : null
  } catch (e) {
    console.log(e)
    return null
  }
}

const findFarmByID = (pool: number) => stakingContractArray[pool]

export const stakeHZN: StakeFunc = async ({ web3, pool, walletAddress, amount }) => {
  try {
    const address = findFarmByID(pool)
    const ct = new web3.eth.Contract(StakingAbi as any, address)
    const contractWithMethod = ct.methods.stake(new BigNumber(amount).times(new BigNumber(10).pow(18)).toFixed())
    const gasLimit = await safeGasEstimates({ contractWithMethod, walletAddress })

    await contractWithMethod.send({ from: walletAddress, gas: gasLimit })
  } catch (e) {
    return false
  }
}

export const unStakeHZN: StakeFunc = async ({ web3, pool, walletAddress, amount }) => {
  try {
    const address = findFarmByID(pool)
    const ct = new web3.eth.Contract(StakingAbi as any, address)
    const contractWithMethod = ct.methods.withdraw(new BigNumber(amount).times(new BigNumber(10).pow(18)).toFixed())
    const gasLimit = await safeGasEstimates({ contractWithMethod, walletAddress })

    await contractWithMethod.send({ from: walletAddress, gas: gasLimit })

    return true
  } catch (e) {
    return false
  }
}

export const getRewardHZN: StakeFunc<Omit<StakeProps, 'amount'>> = async ({ pool, walletAddress, web3 }) => {
  try {
    const address = findFarmByID(pool)
    const ct = new web3.eth.Contract(StakingAbi as any, address)
    const contractWithMethod = ct.methods.getReward()
    const gasLimit = await safeGasEstimates({ contractWithMethod, walletAddress })

    await contractWithMethod.send({ from: walletAddress, gas: gasLimit })

    return true
  } catch (e) {
    return false
  }
}
